import React from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

export let logOutb = false;

const logOut = async (displayMessage) => {
  try {
    if (auth.currentUser) {
      await signOut(auth);
      logOutb = true;
      localStorage.setItem('logOutb', logOutb);
      window.location.reload();
    }
  } catch (error) {
    displayMessage(error.message + ' 🔒', 'error');
  }
};

const LogoutButton = ({ displayMessage }) => (
  <div style={{ borderTop: '1px solid #eee', paddingTop: '25px', marginTop: '25px', textAlign: 'center' }}>
    <button
      onClick={() => logOut(displayMessage)}
      style={{
        padding: '12px 25px',
        borderRadius: '8px',
        border: '2px solid #c82333',
        backgroundColor: '#dc3545',
        color: 'white',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '1.1em',
        transition: 'background-color 0.3s ease, border-color 0.3s ease'
      }}
    >
      Log Out
    </button>
  </div>
);

export { logOut };
export default LogoutButton;
